
window.addEventListener( "load", function () {
    
    const contactForm = document.getElementById('contact_form');

    const contactFormCheck = function(){
        const formData = new FormData(contactForm);

        const inputEmail = formData.get('email');
        const inputMessage = formData.get('message');
        
        let validEmail = false;
        if(/\S+@\S+\.\S+/.test(inputEmail)===true){
            validEmail = true;
        }

        let validMessage = false;
        if( (inputMessage?.trim()?.length || 0) > 0 ){
            validMessage = true;
        }

        if(validEmail && validMessage){
            return true;
        }

        return false;
    }

    const contactFormProcess = function(){

        if( !contactFormCheck() ){
            alert("Uner erreur est survenue. Veuillez vérifier ques les champs du fomulaire sont valides");
            return false;
        }

        var xhr = new XMLHttpRequest();

        xhr.onreadystatechange = function() {
            if (xhr.readyState === 4) {
                const ajaxResponse = JSON.parse(xhr.response);
                //console.log('end ajax', ajaxResponse);

                const replacement = document.createElement('div');
                replacement.classList.add("response");

                if(ajaxResponse.success==1){
                    contactForm.reset();
                    replacement.classList.add("success");

                    replacement.innerHTML = `
                        <h3>Merci !</h3>
                        <p>Votre message m'a bien été envoyé !</p>
                        <p>Vous recevrez une réponse prochainement à l'adresse que vous avez renseignée.</p>
                    `;
                }else{
                    replacement.classList.add("error");
                    replacement.innerHTML = `
                        <h3>Oups !</h3>
                        <p>Veuillez m'excuser, votre message n'a pas pu m'être envoyé.</p>
                        <p>Vous pouvez réessayer plus tard ou bien me contacter via LinkedIn.</p>
                    `;
                }

                contactForm.innerHTML = replacement.outerHTML;
                
            }
        }

        xhr.open("POST", "/contact.php");
        xhr.send(new FormData(contactForm));

        /*fetch('https://jsonplaceholder.typicode.com/users', {
            headers: { "Content-Type": "application/json; charset=utf-8" },
            method: 'POST',
            body: JSON.stringify({
                username: 'Elon Musk',
                email: 'elonmusk@gmail.com',
            })
        })*/

    }

    contactForm.addEventListener( "submit", function ( event ) {
        event.preventDefault();
        contactFormProcess();
    } );

});